import Reveal from "../Reveal";

export default function Manifesto() {
  return (
    <section
      id="about"
      data-testid="manifesto-section"
      className="relative py-24 md:py-40 border-t border-[#2E2E38] overflow-hidden"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute top-1/3 -right-40 w-[700px] h-[700px] rounded-full opacity-25 blur-3xl"
        style={{ background: "radial-gradient(circle, #2A0A3D 0%, transparent 65%)" }}
      />
      <div className="relative max-w-[1600px] mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.25em] text-[#E3FF34] mb-10">
            [ Manifesto ]
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2
            data-testid="manifesto-heading"
            className="font-['Anton'] uppercase leading-[0.92] tracking-tight text-[#A3A3A3] text-5xl md:text-7xl lg:text-[8.5vw] hover:text-[#F2F2F2] transition-colors duration-700"
          >
            We don&apos;t chase clicks.
            <br />
            We build{" "}
            <span className="text-[#E3FF34]">assets that compound</span>{" "}
            <span className="text-[#7C3AED]">—</span> websites, audiences, and
            systems that keep paying you back, long after the campaign ends.
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16 border-t border-[#262626] pt-12">
            {[
              {
                k: "Operator-led",
                v: "We've run brands. We don't outsource judgement to junior account managers.",
              },
              {
                k: "Senior-only",
                v: "Strategy, creative and media handled by people who've done it before.",
              },
              {
                k: "Built in public",
                v: "Weekly reporting. Shared dashboards. No mystery boxes.",
              },
            ].map((b, i) => (
              <div key={b.k} data-testid={`manifesto-pillar-${i}`}>
                <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.25em] text-[#E3FF34]">
                  / {String(i + 1).padStart(2, "0")} — {b.k}
                </p>
                <p className="mt-4 font-['Outfit'] font-light text-[#A3A3A3] text-base md:text-lg leading-relaxed">
                  {b.v}
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
